import axios from '@/libs/api.request.js'

// 获取首页数据
export const getMeasureHomeData = (id) => {
  return axios.request({
    url: '/Measure/GetHomeData',
    params: { id },
    method: 'get'
  })
}

export const getPageList = (page, pageSize, data) => {
  return axios.request({
    url: '/Measure/GetPageList',
    params: {
      page,
      pageSize
    },
    data,
    method: 'post'
  })
}

export const getDetail = (id) => {
  return axios.request({
    url: '/Measure/GetDetail',
    params: { id },
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/measure.js